<template>
  <div>
    <el-row  >
      <el-col :span="16">
        <el-card :body-style="cardBodyStyle">
          <el-input v-model="queryPostName" size="small" placeholder="请输入查询条件" class="sx-input"></el-input>

          <el-button type="primary" size="small" @click="search">查询</el-button>

          <el-button type="primary" size="small" plain @click="handleAdd">新增</el-button>
        </el-card>
        <el-card :body-style="cardBodyStyle">
          <el-table v-loading="loading" :data="tableData" border @row-click="handleCurrentRowChange"
            @sort-change="testChange" ref="table">
            <el-table-column type="index" label="序号" align="center" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + (currentPage - 1) * pageSize + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="postCode" label="岗位编码" width="120" show-overflow-tooltip header-align="center"
              align="center">
            </el-table-column>
            <el-table-column prop="postName" label="岗位名称" show-overflow-tooltip sortable>
            </el-table-column>
            <el-table-column prop="postDesc" label="岗位说明" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" width="200px" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
                <el-button size="mini" plain type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination small @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="totalRows">
          </el-pagination>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card :body-style="cardBodyStyle">
          <el-button type="primary" size="small" plain @click="handleAddUserPost">添加</el-button>
        </el-card>
        <el-card :body-style="cardBodyStyle">
          <el-table :data="tableDataUserPost" border>
            <el-table-column prop="id" label="id" show-overflow-tooltip v-if="isShow">
            </el-table-column>

            <el-table-column prop="user.userName" label="用户名" show-overflow-tooltip header-align="center"
              align="center">
            </el-table-column>
            <el-table-column prop="user.userDesc" label="姓名" show-overflow-tooltip header-align="center" align="center">
            </el-table-column>
            <el-table-column label="操作" width="100px" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleDeleteUserPost(scope.row)">删除</el-button>
              </template>
            </el-table-column>

          </el-table>

        </el-card>
      </el-col>
    </el-row>

    <el-dialog :close-on-click-modal="false" v-dialogDrag title="编辑信息" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="用户编码" v-if="isShow">
          <el-input v-model="form.id" size="small"></el-input>
        </el-form-item>
        <el-form-item label="岗位编码">
          <el-input v-model="form.postCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="岗位名称">
          <el-input v-model="form.postName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="岗位说明">
          <el-input v-model="form.postDesc" size="small"></el-input>
        </el-form-item>

      </el-form>

      <span slot="footer">
        <el-button type="success" size="small" @click="handleSave">保存</el-button>
        <el-button type="danger" size="small" @click="handleCancelSave">取消</el-button>
      </span>

    </el-dialog>


    <el-dialog :close-on-click-modal="false" v-dialogDrag title="编辑信息" :visible.sync="dialogVisibleUser" width="800px">
      <el-input v-model="queryUserDesc" placeholder="请输入查询条件" style="width :300px;float: left;"></el-input>
      <el-button type="info" @click="searchUser">查询</el-button>
      <el-table :data="tableDataUser" border>
        <el-table-column sortable prop="userName" label="用户名" width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column sortable prop="userDesc" label="姓名" width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleAddUser(scope.row)">加入</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination size="mini" @size-change="UserhandleSizeChange" @current-change="UserhandleCurrentChange"
        :current-page="UsercurrentPage" :page-sizes="UserpageSizes" :page-size="UserpageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="UsertotalRows">
      </el-pagination>
    </el-dialog>



  </div>
</template>
<script>
  import axios from '@/axios'
  import tools from '@/tools'
  export default {
    data() {
      return {
        cardBodyStyle: tools.style.card,
        queryUserDesc: '',
        //表格初始化参数
        tableData: [],
        tableDataUser: [],
        tableDataUserPost: [],
        currentPage: 1,
        totalRows: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,
        //查询条件
        queryPostName: '',
        //录入框
        dialogVisible: false,
        dialogVisibleUser: false,
        form: {
          id: '',
          postCode: '',
          postName: '',
          postDesc: ''
        },
        isShow: false,
        loading: true,
        selectedPostId: '',
        userPost: {
          id: '',
          user: {
            id: ''
          },
          post: {
            id: ''
          }
        },
        UsercurrentPage: 1,
        UsertotalRows: 0,
        UserpageSizes: [10, 20, 30, 40],
        UserpageSize: 10,
      }
    },
    //界面渲染完毕调用   初始化表格参数
    mounted() {
      this.getTableData()
    },
    methods: {
      test() {

      },
      testChange(column, prop, order) {
        console.log(column)
        console.log(prop)
        console.log(order)
      },
      // 获取table数据
      getTableData() {
        this.loading = true
        var url = 'framework/SysPost/query.do'
        var param = {
          page: this.currentPage,
          rows: this.pageSize,
          postName: this.queryPostName
        }
        axios.get(url, param).then(response => {
          this.tableData = response.data.data.list
          this.totalRows = response.data.data.total
          this.loading = false
        });
      },
      getTableDataUserPost() {
        var url = 'framework/SysUserPost/queryByPostId.do'
        var param = {
          postId: this.selectedPostId
        }
        axios.get(url, param).then(response => {
          this.tableDataUserPost = response.data.data
        });
      },
      getTableDataUser() {
        var url = 'framework/SysUser/query.do'
        var param = {
          page: this.UsercurrentPage,
          rows: this.UserpageSize,
          userDesc: this.queryUserDesc
        }
        axios.get(url, param).then(response => {
          this.tableDataUser = response.data.data.list
          this.UsertotalRows = response.data.data.total
        });
      },
      handleAddUserPost() {
        if (this.selectedPostId === '') {
          this.$message({
            type: 'error',
            message: '先选择岗位！',
          });
        } else {
          this.dialogVisibleUser = true
        }
      },
      searchUser() {
        this.getTableDataUser()
      },
      handleCurrentRowChange(row) {
        console.log(row.id)
        this.selectedPostId = row.id
        this.getTableDataUserPost()
      },
      // 修改每页条数事件
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val
        this.getTableData()
      },
      // 修改当前页事件
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val
        this.getTableData()
      },

      UserhandleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.UserpageSize = val
        this.getTableDataUser()
      },

      UserhandleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.UsercurrentPage = val
        this.getTableDataUser()
      },

      handleAdd() {
        this.dialogVisible = true
        this.form = {
          id: '',
          postCode: '',
          postName: '',
          postDesc: ''
        }

        var url = 'framework/SysPost/queryNewCode.do'
        var param = {}
        axios.get(url, param).then(response => {
          this.form.postCode = response.data.data.code
        });


      },

      handleEdit(row) {
        this.dialogVisible = true
        this.form = row
      },

      handleSave(row) {
        var url = 'framework/SysPost/save.do'
        var param = {
          id: this.form.id,
          postCode: this.form.postCode,
          postName: this.form.postName,
          postDesc: this.form.postDesc
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.getTableData()
            this.dialogVisible = false
          } else {
            this.$message({
              type: 'error',
              message: '操作失败' + response.data.msg,
            });
          }
        });
      },

      handleAddUser(row) {
        this.userPost.user.id = row.id
        this.userPost.post.id = this.selectedPostId
        var url = 'framework/SysUserPost/save.do'
        var param = {
          json: JSON.stringify(this.userPost)
        }
        axios.post(url, param).then(response => {
          if (response.data.code === 0) {
            this.$message({
              type: 'success',
              message: '修改成功!',
            });
            //this.getTableDataUser()
            this.getTableDataUserPost()
          } else {
            this.$message({
              type: 'error',
              message: '修改失败' + response.data.msg,
            });
          }
        });
      },



      handleCancelSave(row) {
        this.dialogVisible = false
      },

      // 删除按钮事件
      handleDelete(id) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = 'framework/SysPost/remove.do'
          var param = {
            id: id
          }
          axios.post(url, param).then(response => {
            if (response.data.code == '0') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTableData()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败' + response.data.msg
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleDeleteUserPost(row) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = 'framework/SysUserPost/remove.do'
          var param = {
            id: row.id
          }
          axios.post(url, param).then(response => {
            if (response.data.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTableDataUserPost()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败' + response.data.msg
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      search() {
        this.getTableData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/system/post.vue